// Protected.js
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./auth-context";

const Protected = ({ children, status }) => {
  const { authState, authLoading } = useContext(AuthContext);

  if (authLoading) return null;

  if (authState.isLoggedIn && (authState.isSubscribed || authState.isTrialActive)) {
    return children;
  }
  if (authState.isLoggedIn) {
    return <Navigate to='/account/subscription' />;
  }
  return <Navigate to='/account/login' />;
};

export default Protected;
